import { Card, CardBody, CardHeader, Flex, StyleProps } from "@chakra-ui/react";
import { useCapitalActivityHistoryChartRetrieveSuspense } from "gen/endpoints/capital-activity/capital-activity";
import { useTranslation } from "react-i18next";
import { MaybernChartWrapper } from "shared/components/chart/MaybernChartWrapper";
import { moneyLabelFormatter } from "shared/components/chart/utils";
import colors from "theme/colors";

export const FundFamilySummaryChartCapitalHistory: React.FC<
  StyleProps & {
    fundFamilyId: string;
  }
> = ({ fundFamilyId, ...props }) => {
  const { t } = useTranslation(["fundFamily"]);
  const { data: chartData } =
    useCapitalActivityHistoryChartRetrieveSuspense(fundFamilyId);
  return (
    <Card variant="chart" {...props}>
      <CardHeader>{t("fundFamily:summary.charts.history.title")}</CardHeader>
      <CardBody>
        <Flex height="330px">
          <MaybernChartWrapper
            {...chartData}
            seriesConfig={{
              stacked: true,
              cornerRadius: 8,
            }}
            palette={{
              fills: [colors.cyan[100], colors.cyan[400]],
            }}
            yAxis={{
              labelFormatter: moneyLabelFormatter,
            }}
            xAxis={{
              labelFormatter: (params: { value: string }) => params.value,
            }}
            padding={{
              top: 4,
              right: 16,
              bottom: 8,
              left: 16,
            }}
          />
        </Flex>
      </CardBody>
    </Card>
  );
};
